import { confirmLexicalStateInTextComponent } from 'modules/draftjs2lexical';
import * as lexicalHelpers from 'modules/Lexical/helpers';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import { layeredRelations } from 'containers/Relations/selectors';
import { getActiveLayer } from 'hooks/useActiveLayer';
import * as Models from 'models';
import { handleSagaError } from 'services/handleError';
import { setDocument } from '../actions';
import { Action } from '../models';
import { documents as documentsSelector } from '../selectors';

export function* removeAnchor(action: Action.IRemoveAnchor): SagaIterator {
  try {
    if (!action.payload) {
      return;
    }
    const { documentId, anchorBlockKey, relationId } = action.payload;
    const documents: ReturnTypeSaga<typeof documentsSelector> = yield select(documentsSelector);
    const document = documents.get(documentId) as Models.TextComponentMap;
    const relations: ReturnTypeSaga<typeof layeredRelations> = yield select(layeredRelations);
    const relation = relations.get(relationId) as Models.LayeredRegularRelationMap;

    let updatedDocument: Models.TextComponentMap;
    const currentActiveLayer = getActiveLayer();
    const styles = relation?.getIn(['styles', currentActiveLayer])?.toJS() as Models.TextRelationStyles | undefined;
    updatedDocument = confirmLexicalStateInTextComponent(document, styles ?? null);
    updatedDocument = lexicalHelpers.removeSSIAnchorOnComponent(updatedDocument, anchorBlockKey);

    yield put(setDocument(updatedDocument));

  } catch (error) {
    yield call(handleSagaError, error, 'Documents.removeAnchor', 'RemoveAnchor');
  }
}
